import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog } from '@a-type/ui';
import { useState } from 'react';
import { useLocalStorage } from '../hooks/useStorage.js';
export function Explainer({ stages }) {
    const [explainerDismissed, setExplainerDismissed] = useLocalStorage('explainerDismissed', false);
    const [stage, setStage] = useState(0);
    return (_jsx(Dialog, { open: !explainerDismissed, onOpenChange: (open) => {
            if (!open) {
                setExplainerDismissed(true);
            }
        }, children: _jsxs(Dialog.Content, { children: [_jsx(Box, { grow: true, items: "start", gap: true, col: true, children: stages[stage] }), _jsxs(Dialog.Actions, { children: [_jsx(Dialog.Close, { render: _jsx(Button, {}), children: "Skip" }), _jsx(Button, { style: { marginLeft: 'auto' }, emphasis: "primary", onClick: () => {
                                if (stage === stages.length - 1) {
                                    setExplainerDismissed(true);
                                }
                                else {
                                    setStage(stage + 1);
                                }
                            }, children: stage === stages.length - 1 ? 'Got it!' : 'Next' })] })] }) }));
}
//# sourceMappingURL=Explainer.js.map